import { commonGuard } from "../func"
import store from "@/api/store"
import {user} from '@/api/access'

const managementRouter = {
  path: "management",
  component: () => import("@/components/frame/main.vue"),
  children: [
    {
      path: "",
      name: "management",
      beforeEnter: commonGuard,
      redirect: to => {
        let userInfo = user()
        const networkType = store.get("networkType")
        
        if (userInfo.type === 'SubManager') {
          return { name: "manager-approval" }
        }
        
        if (networkType.indexOf("e") === 0) {
          return { name: "userRemote-controlHistory-self" }
        }
        return { name: "function-settings" }
      },
      component: () => import("@/components/management/index.vue"),
      children: [
        {
          path: "function-settings",
          name: "function-settings",
          meta: { auth: ["Manager"] },
          component: () => import("@/components/management/function-settings/index.vue"),
          beforeEnter: commonGuard,
        },
        {
          path: "access",
          name: "access-registration",
          component: () => import("@/components/management/access/index.vue"),
          beforeEnter: commonGuard,
        },
        {
          path: "access-user",
          name: "access-user",
          component: () => import("@/components/management/access-user/index.vue"),
          beforeEnter: commonGuard,
        },
        {
          path: "access-history",
          name: "access-registration-view",
          component: () => import("@/components/management/access-history/index.vue"),
          beforeEnter: commonGuard,
        },
        {
          path: "blocking-settings",
          name: "blocking-settings",
          component: () => import("@/components/management/blocking-settings/index.vue"),
          beforeEnter: commonGuard,
        },
        {
          path: "manager",
          component: { template: "<router-view></router-view>" },
          beforeEnter: commonGuard,
          children: [
            {
              path: "integrated",
              name: "manager-integrated",
              meta: { auth: ["Manager"] },
              component: () => import("@/components/management/managerSettings/integrated.vue"),
              beforeEnter: commonGuard,
            },
            {
              path: "approval",
              name: "manager-approval",
              meta: { auth: ["Manager", "SubManager"] },
              component: () => import("@/components/management/managerSettings/approval.vue"),
              beforeEnter: commonGuard,
            },
            {
              path: "applyHistory",
              name: "manager-applyHistory",
              component: () => import("@/components/management/managerSettings/applyHistory.vue"),
              beforeEnter: commonGuard,
            },
            {
              path: "regDelHistory",
              name: "manager-regDelHistory",
              component: () => import("@/components/management/managerSettings/regDelHistory.vue"),
              beforeEnter: commonGuard,
            },
          ],
        },
        {
          path: "agent",
          component: { template: "<router-view></router-view>" },
          beforeEnter: commonGuard,
          children: [
            {
              path: "integrated",
              name: "agent-integrated",
              meta: { auth: ["Manager"] },
              component: () => import("@/components/management/agentSettings/integrated.vue"),
              beforeEnter: commonGuard,
            },
            {
              path: "approval",
              name: "agent-approval",
              meta: { auth: ["Manager", "SubManager"] },
              component: () => import("@/components/management/agentSettings/approval.vue"),
              beforeEnter: commonGuard,
            },
            {
              path: "applyHistory",
              name: "agent-applyHistory",
              component: () => import("@/components/management/agentSettings/applyHistory.vue"),
              beforeEnter: commonGuard,
            },
            {
              path: "regDelHistory",
              name: "agent-regDelHistory",
              component: () => import("@/components/management/agentSettings/regDelHistory.vue"),
              beforeEnter: commonGuard,
            },
          ],
        },
        {
          path: "userRemote",
          component: { template: "<router-view></router-view>" },
          beforeEnter: commonGuard,
          children: [
            {
              path: "approval",
              name: "userRemote-approval",
              meta: { auth: ["Manager", "SubManager"] },
              component: () => import("@/components/management/userRemote/approval.vue"),
              beforeEnter: commonGuard,
            },
            {
              path: "history",
              name: "userRemote-history",
              component: () => import("@/components/management/userRemote/history.vue"),
              beforeEnter: commonGuard,
            },
            {
              path: "controlHistory",
              name: "userRemote-controlHistory",
              component: () => import("@/components/management/userRemote/controlHistory.vue"),
              beforeEnter: commonGuard,
            },
            {
              path: "controlHistorySelf",
              name: "userRemote-controlHistory-self",
              component: () => import("@/components/management/userRemote/controlHistorySelf.vue"),
              beforeEnter: commonGuard,
            },
          ],
        },
      ],
    },
  ],
}

export default managementRouter
